import { IconButton } from '@moonpig/launchpad-components'
import React from 'react'
import { IconSystemArrowForward } from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import {
  RangeFieldTypes,
  RangeFilterInput,
  useRangeFilterInput,
} from '../../RangeFilterInput'
import { useSearchStore } from '../../../store/SearchStore'
import { FilterSource } from '../../../types'

const StyledInputForm = styled.form`
  display: flex;
  width: 100%;

  ${s({
    gap: 8,
    alignItems: { xs: 'end', md: 'start', lg: 'end' },
    flexDirection: { xs: 'row', md: 'column', lg: 'row' },
  })}
`

const StyledIconButton = styled(IconButton)`
  width: 44px;
  height: 44px;
  margin: 2px;

  ${s({
    bgcolor: 'colorInteractionButton',
    color: 'colorTextInverted',
  })}

  &:not(:disabled) {
    &:hover,
    &:hover:active {
      ${s({
        bgcolor: 'colorInteractionButtonHover',
        color: 'colorTextInverted',
      })}
    }

    &:focus,
    &:active {
      ${s({
        bgcolor: 'colorInteractionButtonFocus',
        color: 'colorTextInverted',
      })}
    }
  }
`

export const InputForm = ({
  filterId,
  ctaTitle,
}: {
  ctaTitle: string
  filterId: string
}) => {
  const onRangeFilterChange = useSearchStore(store => store.onRangeFilterChange)
  const applyRangeFilter = useSearchStore(store => store.applyRangeFilter)
  const rangeFilters = useSearchStore(store => store.rangeFilters)
  const { createConfiguration, isRangeFilterValueValid } = useRangeFilterInput()
  const rangeFilterValue = rangeFilters.find(f => f.name === filterId)?.value

  const hasValidValue = isRangeFilterValueValid(
    RangeFieldTypes.age,
    rangeFilterValue,
  )

  return (
    <StyledInputForm
      onSubmit={e => {
        e.preventDefault()
        applyRangeFilter({
          filterId,
          value: rangeFilterValue || /* istanbul ignore next */ '',
          source: FilterSource.EntryPointBanner,
        })
      }}
    >
      <RangeFilterInput
        onChange={(ageInput: string) =>
          onRangeFilterChange({
            filterId,
            value: ageInput,
          })
        }
        input={createConfiguration(RangeFieldTypes.age, rangeFilterValue)}
        hasValidValue={hasValidValue}
        noBorder
        inputCtaComponent={
          <StyledIconButton
            type="submit"
            icon={IconSystemArrowForward}
            label={ctaTitle}
            disabled={!hasValidValue || !rangeFilterValue}
          />
        }
      />
    </StyledInputForm>
  )
}
